import React, { Component } from "react";
import { propertyUtil } from "views/Pma/PropertyUtil";
import MiniCompassLogo from "_img/brokerage-logos/compass-white-brokerage-logo.png";
import "./print.scss";

class QVFourProducedByFooter extends Component {
  render() {
    let {
      brokerageName,
      listgenUserFirstName,
      listgenUserLastName,
      isMemberOfTeam,
      teamMembers,
      teamName,
      listgenUserID,
      agentLicenseNumber,
    } = this.props.agentData;
    const { currentSoldListings, printVersion, coverPageDetails } = this.props;
    if (listgenUserID === "116385") {
      listgenUserLastName = `${listgenUserLastName}, MBA`;
    }
    const { countyID } = coverPageDetails;
    const { mlsAreaID, mlsCityID } = this.props.currentArea;

    const isBerkshire =
      (brokerageName.includes("Berkshire") &&
        brokerageName.includes("Hathaway")) ||
      (brokerageName.includes("berkshire") && listgenUserID === "101");

    const { formatDaySuffix, getPhotoCredit } = propertyUtil;
    let date = new Date();

    const today = `${date.getDate()}`;
    const month = date.toLocaleString("default", { month: "long" });
    const thisYear = date.getFullYear();

    const formattedMonth = `${date.getMonth() + 1}`.padStart(2, "0");
    const formattedDay = `${date.getDate()}`.padStart(2, "0");
    const formattedDate = `${formattedMonth}/${formattedDay}/${date.getFullYear()}`;
    const formattedUpdatedAt = ` ${formattedDate}`;

    const isScar = teamName === "Team Scarborough";
    const isAmberRussell = listgenUserID === "100040";

    const { blackBorder, filterBrokerage } = propertyUtil;
    let hasBlackBorder = false;
    if (listgenUserID === "104412") {
      hasBlackBorder = true;
    }
    const {
      formatSuffix,

      emptyValueCheck,
      formatAddress,
    } = propertyUtil;
    if (listgenUserID === "107373" || listgenUserID === "107876") {
      brokerageName = "KINDRED REALTY";
    }
    let isCountryClubGate = mlsAreaID === "132" ? true : false;
    let useCompassLegal = false;

    if (
      (brokerageName.toLowerCase() === "compass" && mlsAreaID.includes("AL")) ||
      mlsAreaID.includes("CCA") ||
      mlsAreaID.includes("NPA") ||
      mlsAreaID.includes("SNM") ||
      mlsAreaID.includes("MRN") ||
      mlsAreaID.includes("SFO")
    ) {
      useCompassLegal = true;
    }
    let isKyleTeam3 = listgenUserID === "103406";
    let isJohnsons = listgenUserID === "100988";
    let teamOf3 =
      isMemberOfTeam && Array.isArray(teamMembers) && teamMembers.length >= 3;
    let ampersand = "&";
    if (isJohnsons) {
      ampersand = "and";
    }
    let useEastBaySource = false;
    if (listgenUserID === "109973" || listgenUserID === "109938") {
      useEastBaySource = true;
    }
    let isSCCompass = brokerageName === "Compass" && useCompassLegal;
    let useFullName = false;
    if (
      listgenUserID === "109651" ||
      listgenUserID === "107232" ||
      listgenUserID === "116045"
    ) {
      useFullName = true;
    }
    let useFullNameSingularLastName = false;
    if (listgenUserID === "107373" || listgenUserID === "107876") {
      useFullNameSingularLastName = true;
    }
    //add comment
    let SCSMCompassDisclaimer = false;
    if (
      mlsAreaID.includes("SCL") ||
      (mlsAreaID.includes("SM") &&
        brokerageName.toLowerCase().includes("compass"))
    ) {
      SCSMCompassDisclaimer = true;
    }

    let useMtrySantaCruzSBCompassDisclaimer = false;
    if (
      (countyID === "27" || countyID === "42" || countyID === "44") &&
      brokerageName.toLowerCase().includes("compass")
    ) {
      useMtrySantaCruzSBCompassDisclaimer = true;
    }
    let presentedByStyles = "";
    if (listgenUserID === "100462") {
      presentedByStyles = "produced-by-footer-height-52";
    }
    if (listgenUserID === "109834") {
      return (
        <div
          className={`${
            printVersion
              ? "print-qv4-produced-by-footer"
              : "editor-qv4-produced-by-footer"
          } ${hasBlackBorder && "black-produced-by"} berk-footer
          `}
        >
          <div>
            Michelle Battermann is a real estate salesperson licensed by the
            state of California affiliated with eXp Realty. eXp Realty is a real
            estate broker licensed by the State of California and abides by
            Equal Housing Opportunity laws. License Number 01878277. All
            material presented herein is intended for informational purposes
            only and is compiled from sources deemed reliable but has not been
            verified. Changes in price, condition, sale or withdrawal may be
            made without notice. No statement is made as to the accuracy of any
            description. All measurements and square footage are approximate. If
            your property is currently listed for sale this is not a
            solicitation.
          </div>
        </div>
      );
    } else if (useMtrySantaCruzSBCompassDisclaimer) {
      return (
        <div
          className={`${
            printVersion
              ? "print-qv4-produced-by-footer"
              : "editor-qv4-produced-by-footer"
          } ${hasBlackBorder && "black-produced-by"} berk-footer
          `}
        >
          <div>
            Compass is a real estate broker licensed by the State of California
            and abides by Equal Housing Opportunity laws. License Numbers
            01991628, 01527235, 01527365. All material presented herein is
            intended for informational purposes only and is compiled from
            sources deemed reliable but have not been verified. Changes in
            price, condition, sale or withdrawal may be made without notice. No
            statement is made as to the accuracy of any description. All
            measurements and square footage are approximate.
          </div>
        </div>
      );
    } else if (listgenUserID === "x103455") {
      return (
        <div
          className={
            printVersion
              ? "print-alt-qv4-produced-by-footer-with-names"
              : "editor-alt-qv4-produced-by-footer-with-names"
          }
        >
          <div className="row-title">
            THE PROPERTY PHOTOS SHOWN ABOVE ARE COURTESY OF THE FOLLOWING REAL
            ESTATE AGENTS:
          </div>
          <div className="names-row">
            <div className="names-col">
              {currentSoldListings.slice(0, 3).map((list) => (
                <div className="place" key={formatAddress(list, mlsAreaID)}>
                  {formatAddress(list, mlsAreaID)} | {list.listingAgentName} |
                  MLS# {list.listingAgentLicenseID}
                </div>
              ))}
            </div>

            <div className="names-col">
              {currentSoldListings.slice(3, 6).map((list) => (
                <div className="place" key={formatAddress(list, mlsAreaID)}>
                  {formatAddress(list, mlsAreaID)} | {list.listingAgentName} |
                  MLS# {list.listingAgentLicenseID}
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    } else if (listgenUserID === "100190") {
      return (
        <div
          className={`${
            printVersion
              ? "print-qv4-produced-by-footer"
              : "editor-qv4-produced-by-footer"
          } ${hasBlackBorder && "black-produced-by"}
          `}
        >
          <p>
            Compiled and Presented by Team Zech Properties / Coldwell Banker
            Realty
          </p>
        </div>
      );
    } else if (SCSMCompassDisclaimer) {
      return (
        <div
          className={`${
            printVersion
              ? "print-qv4-produced-by-footer"
              : "editor-qv4-produced-by-footer"
          } ${hasBlackBorder && "black-produced-by"} berk-footer
          `}
        >
          <div>
            Compass is a real estate broker licensed by the State of California
            and abides by Equal Housing Opportunity laws. License Number
            01991628, 01527235, 01527365. All material presented herein is
            intended for informational purposes only and is compiled from
            sources deemed reliable but have not been verified. Changes in
            price, condition, sale or withdrawal may be made without notice. No
            statement is made as to the accuracy of any description. All
            measurements and square footage are approximate.{" "}
            {useEastBaySource && "Source: Bay East AOR"}
          </div>
        </div>
      );
    } else if (isSCCompass) {
      return (
        <div
          className={`${
            printVersion
              ? "print-qv4-produced-by-footer"
              : "editor-qv4-produced-by-footer"
          } ${hasBlackBorder && "black-produced-by"} berk-footer
          `}
        >
          <div>
            Compass is a real estate broker licensed by the State of California
            and abides by Equal Housing Opportunity laws. License Number
            01991628, 01527235, 01527365. All material presented herein is
            intended for informational purposes only and is compiled from
            sources deemed reliable but have not been verified. Changes in
            price, condition, sale or withdrawal may be made without notice. No
            statement is made as to the accuracy of any description. All
            measurements and square footage are approximate. Data is provided by
            CCAR MLS, BAREIS©, Bay East MLS, or BridgeMLS for consumer personal
            use in identifying prospective properties for purchase and may not
            be used for any other purpose. Listings may or may not be listed by
            the Broker/Agent providing this information. Data last updated on
            {formattedUpdatedAt}.
          </div>
        </div>
      );
    } else if (isBerkshire) {
      return (
        <div
          className={`${
            printVersion
              ? "print-qv4-produced-by-footer"
              : "editor-qv4-produced-by-footer"
          } ${hasBlackBorder && "black-produced-by"} berk-footer ${presentedByStyles}
          `}
        >
          <div>
            ©{thisYear} Berkshire Hathaway HomeServices California Properties
            (BHHSCP) is a member of the franchise system of BHH Affiliates LLC.
            BHHS and the BHHS symbol are registered service marks of Columbia
            Insurance Company, a Berkshire Hathaway affiliate. BHH Affiliates
            LLC and BHHSCP do not guarantee accuracy of all data including
            measurements, conditions, and features of property. Information is
            obtained from various sources and will not be verified by broker or
            MLS. Buyer is advised to independently verify the accuracy of that
            information. Based on information obtained from the MLS as of{" "}
            {month} {today}, {thisYear}. Display of MLS data is deemed reliable
            but is not guaranteed accurate by the MLS.{" "}
          </div>
        </div>
      );
    } else {
      return (
        <div>
          {isMemberOfTeam ? (
            <div
              className={`${
                printVersion
                  ? "print-qv4-produced-by-footer"
                  : "editor-qv4-produced-by-footer"
              } ${hasBlackBorder && "black-produced-by"}
              `}
            >
              {isAmberRussell ? (
                <p>
                  Compiled and Presented by {listgenUserFirstName}{" "}
                  {listgenUserLastName} & {teamMembers[1].firstName}{" "}
                  {teamMembers[1].lastName}
                </p>
              ) : useFullName ? (
                <p>
                  Compiled and Presented by {listgenUserFirstName}{" "}
                  {listgenUserLastName} & {teamMembers[1].firstName}{" "}
                  {teamMembers[1].lastName}
                </p>
              ) : useFullNameSingularLastName ? (
                <p>
                  Compiled and Presented by {listgenUserFirstName} &{" "}
                  {teamMembers[1].firstName} {listgenUserLastName}
                </p>
              ) : isKyleTeam3 ? (
                <p>Compiled by MORRISON, ALTMAN & FROMM</p>
              ) : isScar ? (
                <p>Compiled and Presented by {teamName}</p>
              ) : isJohnsons ? (
                <p>Compiled and Presented by Dianne and Brianna Johnson</p>
              ) : (listgenUserID === "109938" || listgenUserID === "109973") &&
                teamMembers?.[1] &&
                teamMembers?.[2] ? (
                <div className="produced-by-footer-east-bay-source">
                  <p>
                    Compiled and Presented by {listgenUserFirstName},{" "}
                    {teamMembers[1].firstName}, and{" "}
                    {teamMembers[2].firstName}{" "}
                  </p>
                  <div className="produced-by-divider">|</div>
                  <p>Source: Bay East AOR</p>
                </div>
              ) : (listgenUserID === "109938" || listgenUserID === "109973") &&
                teamMembers?.[1] ? (
                <div className="produced-by-footer-east-bay-source">
                  <p>
                    Compiled and Presented by {listgenUserFirstName} &{" "}
                    {teamMembers[1].firstName}
                  </p>
                  <div className="produced-by-divider">|</div>
                  <p>Source: Bay East AOR</p>
                </div>
              ) : teamOf3 && teamMembers?.[1] && teamMembers?.[2] ? (
                <p>
                  Compiled and Presented by {listgenUserFirstName},{" "}
                  {teamMembers[1].firstName}, and{" "}
                  {teamMembers[2].firstName}{" "}
                </p>
              ) : (
                <p>
                  Compiled and Presented by {listgenUserFirstName}
                  {teamMembers?.[1] ? <> & {teamMembers[1].firstName}</> : null}
                </p>
              )}
              <div className="produced-by-divider">|</div>
              {brokerageName.toLowerCase() === "compass" ? (
                <div>
                  <img
                    src="https://d2onbxnrte2nim.cloudfront.net/Horizontal_White_Compass%20Logo_500px.png"
                    className="presented-by-compass-logo"
                    alt="Compass logo"
                  />
                </div>
              ) : (
                <p>{filterBrokerage(brokerageName)}</p>
              )}
            </div>
          ) : brokerageName === "HideBrokerage" ? (
            <div
              className={`${
                printVersion
                  ? "print-qv4-produced-by-footer"
                  : "editor-qv4-produced-by-footer"
              } ${hasBlackBorder && "black-produced-by"}
              `}
            >
              <p className="no-mt-produced-by">
                Compiled and Presented by {listgenUserFirstName}{" "}
                {listgenUserLastName}
              </p>
            </div>
          ) : (
            <div
              className={`${
                printVersion
                  ? "print-qv4-produced-by-footer"
                  : "editor-qv4-produced-by-footer"
              } ${hasBlackBorder && "black-produced-by"}
              `}
            >
              <p className="no-mt-produced-by">
                Compiled and Presented by {listgenUserFirstName}{" "}
                {listgenUserLastName}
              </p>
              <div className="produced-by-divider">|</div>
              {brokerageName.toLowerCase() === "compass" ? (
                <div>
                  <img
                    src="https://d2onbxnrte2nim.cloudfront.net/Horizontal_White_Compass%20Logo_500px.png"
                    className="presented-by-compass-logo"
                    alt="Compass logo"
                  />
                </div>
              ) : (
                <p>{filterBrokerage(brokerageName)}</p>
              )}
            </div>
          )}
        </div>
      );
    }
  }
}

export default QVFourProducedByFooter;
